// 添加弹框视频
// function popu(ele, type) {
//   for (var i = 0; i < ele.length; i++) {
//     ele[i].addEventListener("click", function (e) {
//       e.preventDefault();
//       var header = document.getElementsByTagName("header")[0];
//       var main = document.getElementsByTagName("main")[0];
//       var footer = document.getElementsByTagName("footer")[0];
//       var body = document.getElementsByTagName("body")[0];
//       var w = document.createElement("aside");
//       var p = document.createElement("div");
//       var f = document.createElement("iframe");
//       document.body.style.overflow='hidden';
//       document.body.style.height='100vh';
//       w.setAttribute("id", "popu-cont");
//       if (type === "video") {
//         w.innerHTML = '<div class="popu-mask" style="position: fixed;width: 100%;height: 100%;left: 0;right: 0;z-index: 1;"></div><div class="popu-wrap text-center"><svg width="32" height="32" viewBox="0 0 24 24" class="transition-linear close-btn"> <use xlink:href="#close-path"><path d="M11 11V6a1 1 0 0 1 2 0v5h5a1 1 0 0 1 0 2h-5v5a1 1 0 0 1-2 0v-5H6a1 1 0 0 1 0-2h5z"></path></use> </svg></div>';
//         var href = this.getAttribute("href");
//         f.setAttribute("src", href);
//         f.setAttribute("allow", "autoplay; encrypted-media");
//         f.setAttribute("allowfullscreen", "allowfullscreen");
//         // f.setAttribute("autoplay", "false");
//         w.querySelector(".popu-wrap").appendChild(f);
//         w.querySelector(".popu-wrap").appendChild(p);

//       } else if (type === "image") {
//         w.innerHTML = '<div class="popu-wrap text-center"><svg width="32" height="32" viewBox="0 0 24 24" class="transition-linear close-btn"> <use xlink:href="#close-path"></use> </svg></div>';
//         w.querySelector(".popu-wrap").appendChild(this.cloneNode(!0))
//       } else if (type === "image-other") {
//         w.innerHTML = '<div class="popu-wrap popu-wrap-other text-center"><svg width="32" height="32" viewBox="0 0 24 24" class="transition-linear close-btn"> <use xlink:href="#close-path"></use> </svg></div>';
//         w.querySelector(".popu-wrap").appendChild(this.cloneNode(!0))
//       }
//       w.querySelector(".popu-wrap").classList.add(type);
//       body.appendChild(w);
//       clickCloseAll(".close-btn");
//       clickCloseAll(".popu-mask");
//       function clickCloseAll(className) {
//         document.querySelector(className).addEventListener('click', function (e) {
//         document.body.style='';
//           if (isIE()) {
//             document.getElementById("popu-cont").removeNode(!0)
//           } else {
//             document.getElementById("popu-cont").remove()
//           }
//         })
//       }
//       function isIE() {
//         if (!!window.ActiveXobject || "ActiveXObject" in window) {
//           return !0
//         } else {
//           return !1
//         }
//       }
//     })
//   }
// }
function popu(ele, type) {
  for (var i = 0; i < ele.length; i++) {
    ele[i].addEventListener("click", function (e) {
      var screenWidth =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;
      e.preventDefault();
      var body = document.getElementsByTagName("body")[0];
      var w = document.createElement("aside");
      // 创建视频元素
      var videoPlayer = document.createElement("video");
      videoPlayer.setAttribute("id", "videoPlayer");
      videoPlayer.setAttribute("controls", "true");
      videoPlayer.setAttribute("playsinline", "true");
      videoPlayer.setAttribute("muted", "muted");
      videoPlayer.setAttribute("preload", "metadata");
      videoPlayer.setAttribute("autoplay", "true");
      // 创建视频源元素
      var videoSource = document.createElement("source");
      document.body.style.overflow = "hidden";
      document.body.style.height = "100vh";
      w.setAttribute("id", "popu-cont");
      w.setAttribute("class", "popu-cont-cutom");
      if (type === "video") {
        w.innerHTML =
          '<div class="popu-mask" style="position: fixed;width: 100%;height: 100%;left: 0;right: 0;z-index: 1;"></div><div class="popu-wrap text-center video-wrapper--native "><svg width="32" height="32" viewBox="0 0 24 24" class="transition-linear close-btn"> <use xlink:href="#close-path"><path d="M11 11V6a1 1 0 0 1 2 0v5h5a1 1 0 0 1 0 2h-5v5a1 1 0 0 1-2 0v-5H6a1 1 0 0 1 0-2h5z"></path></use> </svg></div>';
        // var href = this.getAttribute("href");
        var href = this.getAttribute("data-mobile-href")
          ? screenWidth < 768
            ? this.getAttribute("data-mobile-href")
            : this.getAttribute("href")
          : this.getAttribute("href");
        videoSource.src = href;
        // 将视频源元素添加到视频元素中
        videoPlayer.appendChild(videoSource);
        w.querySelector(".popu-wrap").appendChild(videoPlayer);
      }
      w.querySelector(".popu-wrap").classList.add(type);
      body.appendChild(w);
      clickCloseAll(".close-btn");
      clickCloseAll(".popu-mask");
      function clickCloseAll(className) {
        document
          .querySelector(className)
          .addEventListener("click", function (e) {
            document.body.style = "";
            if (isIE()) {
              document.getElementById("popu-cont").removeNode(!0);
            } else {
              document.getElementById("popu-cont").remove();
            }
          });
      }
      function isIE() {
        if (!!window.ActiveXobject || "ActiveXObject" in window) {
          return !0;
        } else {
          return !1;
        }
      }
    });
  }
}
// 添加订阅弹窗
function subscriptePopu(ele) {
  for (var i = 0; i < ele.length; i++) {
    ele[i].addEventListener("click", function (e) {
      e.preventDefault();
      document.getElementById("popu_subscripte").style.display = "block";
      document.getElementById("mobile-menu-drawer").removeAttribute("open");
      document.body.style.overflow = "hidden";
      document.body.style.height = "100vh";
      clickCloseAll(".close-btn-header");
      clickCloseAll(".popu-mask-header");
      function clickCloseAll(className) {
        document
          .querySelector(className)
          .addEventListener("click", function (e) {
            document.body.style = "";
            document.getElementById("popu_subscripte").style.display = "none";
            e.stopPropagation();
          });
      }
      function isIE() {
        if (!!window.ActiveXobject || "ActiveXObject" in window) {
          return !0;
        } else {
          return !1;
        }
      }
    });
  }
}
function targetElement(elementId) {
  for (var i = 0; i < elementId.length; i++) {
    elementId[i].addEventListener("click", function (e) {
      e.preventDefault();
      console.log("e", e.target.dataset.navid);
      var targetElement = document.getElementById(e.target.dataset.navid);
      targetElement.scrollIntoView({ behavior: "smooth" });
    });
  }
}

function applyCouponCode(code) {
  // let oldCode = getCookie('discount_code');
  // setCookie('discount_code', code, 3);
  // 为空不用清空 code
  autoDiscountCode(code);
}
/**
 *
 * @param {产品id} productId
 * @param {按钮是否需要动画} button
 * @param {扩展字段} properties
 * @param {带入code} code
 * @returns
 */
function addToCart(productId, button, properties, code = "", quantity = 1) {
  // 获取文本元素和加载动画元素
  var textElement;
  var loaderElement;
  if (button) {
    textElement = button.querySelector(".loader-button__text");
    loaderElement = button.querySelector(".loader-button__loader");

    if (button.disabled) return;
    // 禁用按钮
    button.setAttribute("disabled", "disabled");
    button.setAttribute("aria-busy", "true");
    // 显示加载动画
    textElement.hidden = true;
    loaderElement.hidden = false;
  }
  if (code) {
    autoDiscountCode(code);
  }

  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      id: productId,
      quantity: quantity, // 可根据需求设置购买数量
      properties,
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      // 添加购物车成功后的处理逻辑
      console.log("Product added to cart:", data);
      // 获取购物车列表
      fetch("/cart.js")
        .then((response) => response.json())
        .then((cartData) => {
          if (code) {
            autoDiscountCode(code);
          }
          // 获取购物车列表成功后的处理逻辑
          console.log("Cart contents:", cartData);
          cartData["sections"] = data["sections"];
          document.documentElement.dispatchEvent(
            new CustomEvent("cart:refresh", {
              bubbles: true,
              detail: {
                cart: cartData,
                openMiniCart:
                  window.themeVariables.settings.cartType === "drawer",
              },
            })
          );
          if (button) {
            // 恢复按钮状态
            button.removeAttribute("disabled");
            button.removeAttribute("aria-busy");
            // 显示 "Add to Cart"，隐藏加载动画
            textElement.hidden = false;
            loaderElement.hidden = true;
          }
        })
        .catch((error) => {
          // 获取购物车列表失败的处理逻辑
          console.error("Error getting cart contents:", error);
          if (button) {
            // 恢复按钮状态
            button.removeAttribute("disabled");
            button.removeAttribute("aria-busy");
            // 显示 "Add to Cart"，隐藏加载动画
            textElement.hidden = false;
            loaderElement.hidden = true;
          }
        });
    })
    .catch((error) => {
      // 添加购物车失败的处理逻辑
      console.error("Error adding product to cart:", error);
    });
}

// 加购处理回调
function addToCartPromise(
  productId,
  button,
  properties,
  code = "",
  quantity = 1
) {
  return new Promise((resolve, reject) => {
    // 获取文本元素和加载动画元素
    var textElement;
    var loaderElement;
    if (button) {
      textElement = button.querySelector(".loader-button__text");
      loaderElement = button.querySelector(".loader-button__loader");

      if (button.disabled) return;
      // 禁用按钮
      button.setAttribute("disabled", "disabled");
      button.setAttribute("aria-busy", "true");
      // 显示加载动画
      textElement.hidden = true;
      loaderElement.hidden = false;
    }

    console.log(properties);

    if (code) {
      autoDiscountCode(code);
    }

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: productId,
        quantity: quantity, // 可根据需求设置购买数量
        properties,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        // 获取购物车列表
        return fetch("/cart.js")
          .then((response) => response.json())
          .then((cartData) => {
            cartData["sections"] = data["sections"];
            document.documentElement.dispatchEvent(
              new CustomEvent("cart:refresh", {
                bubbles: true,
                detail: {
                  cart: cartData,
                  openMiniCart:
                    window.themeVariables.settings.cartType === "drawer",
                },
              })
            );

            if (button) {
              // 恢复按钮状态
              button.removeAttribute("disabled");
              button.removeAttribute("aria-busy");
              // 显示 "Add to Cart"，隐藏加载动画
              textElement.hidden = false;
              loaderElement.hidden = true;
            }

            // Resolve the Promise with the cart data
            resolve(cartData);
          });
      })
      .catch((error) => {
        console.error(
          "Error adding product to cart or getting cart contents:",
          error
        );

        if (button) {
          // 恢复按钮状态
          button.removeAttribute("disabled");
          button.removeAttribute("aria-busy");
          // 显示 "Add to Cart"，隐藏加载动画
          textElement.hidden = false;
          loaderElement.hidden = true;
        }

        // Reject the Promise with the error
        reject(error);
      });
  });
}

function buyProduct(productId, properties, code = "", quantity = 1) {
  fetch("/cart/clear.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then(() => {
      if (code) {
        autoDiscountCode(code);
      }
      // 购物车已清空，跳转到结账页面
      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: productId,
          quantity: quantity, // 可根据需求设置购买数量
          properties,
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          fetch("/checkout", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              productId: productId,
              quantity: 1,
              form_type: "product",
              utf8: "✓",
            }),
          })
            .then((response) => {
              console.log("response", response);
              if (response.status === 302) {
                // 获取重定向的 URL
                var redirectUrl = response.headers.get("Location");
                // 执行重定向
                window.location.href = redirectUrl;
              } else {
                // 处理其他状态码的逻辑
                return response;
              }
            })
            .then((data) => {
              // 处理购买成功后的逻辑
              console.log("Purchase successful:", data);
              // 执行跳转
              window.location.href = data.url;
              // 可以根据需求执行其他操作，例如显示购买成功提示、跳转到订单页面等
            })
            .catch((error) => {
              // 处理购买失败的逻辑
              console.error("Purchase failed:", error);
              // 可以根据需求执行其他错误处理操作
            });
        })
        .catch((error) => {
          // 添加购物车失败，处理错误
          console.error("Error clearing cart:", error);
        });
    })
    .catch((error) => {
      // 清空购物车失败，处理错误
      console.error("Error clearing cart:", error);
    });
}

// 定义函数来滚动到特定的 section
function scrollToSection(sectionId) {
  var section = document.getElementById(sectionId);
  section.scrollIntoView({ behavior: "smooth" });
}

// 检查元素是否在视口内的辅助函数
function isElementInViewport(el) {
  var rect = el.getBoundingClientRect();
  return rect.top <= 0 && rect.bottom >= 0;
}

function textDialog(ele) {
  for (var i = 0; i < ele.length; i++) {
    ele[i].addEventListener("click", function (e) {
      e.preventDefault();
      var body = document.getElementsByTagName("body")[0];
      var w = document.createElement("aside");
      document.body.style.overflow = "hidden";
      document.body.style.height = "100vh";
      w.setAttribute("id", "popu-cont");
      w.setAttribute("class", "popu-cont-cutom popu-cont-cutom-txt");
      w.innerHTML = `<div class="popu-mask" style="position: fixed;width: 100%;height: 100%;left: 0;right: 0;z-index: 1;"></div>
      <div class="popu-wrap text-center"><svg width="32" height="32" viewBox="0 0 24 24" class="transition-linear close-btn"> <use xlink:href="#close-path"><path d="M11 11V6a1 1 0 0 1 2 0v5h5a1 1 0 0 1 0 2h-5v5a1 1 0 0 1-2 0v-5H6a1 1 0 0 1 0-2h5z"></path></use> </svg>
        <div class="popup_text-contend">

       <h1 class="heading h2">Lucky Draw Rules</h1><p class="p" style="margin-top:3.0000pt;margin-right:0.0000pt;margin-bottom:3.0000pt;
        margin-left:0.0000pt;mso-pagination:widow-orphan;text-align:left;
        line-height:130%;"><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
        mso-bidi-font-family:'Times New Roman';line-height:130%;color:rgb(51,51,51);
        letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
        font-size:11.0000pt;mso-font-kerning:1.0000pt;">Rules: Winners will be randomly selected from all valid prize draw entries. </span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
        mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:3.0000pt;margin-right:0.0000pt;margin-bottom:3.0000pt;
        margin-left:0.0000pt;mso-pagination:widow-orphan;text-align:left;
        line-height:130%;"><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
        mso-bidi-font-family:'Times New Roman';line-height:130%;color:rgb(51,51,51);
        letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
        font-size:11.0000pt;mso-font-kerning:1.0000pt;">Introduction of the Event</span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
        mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:3.0000pt;margin-right:0.0000pt;margin-bottom:3.0000pt;
        margin-left:0.0000pt;mso-pagination:widow-orphan;text-align:left;
        line-height:130%;"><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
        mso-bidi-font-family:'Times New Roman';line-height:130%;color:rgb(51,51,51);
        letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
        font-size:11.0000pt;mso-font-kerning:1.0000pt;">1. The "Travel Light, Travel Hair-free" campaign ("campaign") and Lucky Draw ("Lucky Draw") are organized by Ulike and hosted on the Ulike website ulike.com. The Campaign and Lucky Draw will commence on 19 July 2023 (CEST) and conclude on 23 August 2023 (CEST) ("Campaign Period"). Ulike reserves the right to shorten or extend the Campaign Period at its sole discretion without prior notice.</span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
        mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:3.0000pt;margin-right:0.0000pt;margin-bottom:3.0000pt;
        margin-left:0.0000pt;mso-pagination:widow-orphan;text-align:left;
        line-height:130%;"><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
        mso-bidi-font-family:'Times New Roman';line-height:130%;color:rgb(51,51,51);
        letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
        font-size:11.0000pt;mso-font-kerning:1.0000pt;">Eligibility</span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
        mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:3.0000pt;margin-right:0.0000pt;margin-bottom:3.0000pt;
        margin-left:16.8000pt;text-indent:-16.8000pt;mso-pagination:widow-orphan;
        text-align:left;line-height:130%;mso-list:l0 level1 lfo1;"><!--[if !supportLists]--><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:12.0000pt;
        mso-font-kerning:1.0000pt;"><span style="mso-list:Ignore;">1.<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
        mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:1.0000pt;">&nbsp;</span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
        mso-bidi-font-family:'Times New Roman';line-height:130%;color:rgb(51,51,51);
        letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
        font-size:11.0000pt;mso-font-kerning:1.0000pt;">The Lucky Draw is open to all registered Ulike users on ulike.com who are US citizens and 18 years old and above as of 9:00 on 19 July 2023 (CEST) ("participant(s)").</span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
        mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:3.0000pt;margin-right:0.0000pt;margin-bottom:3.0000pt;
        margin-left:0.0000pt;mso-pagination:widow-orphan;text-align:left;
        line-height:130%;"><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
        mso-bidi-font-family:'Times New Roman';line-height:130%;color:rgb(51,51,51);
        letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
        font-size:11.0000pt;mso-font-kerning:1.0000pt;">Lucky Draw Mechanism</span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
        mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:3.0000pt;margin-right:0.0000pt;margin-bottom:3.0000pt;
        margin-left:0.0000pt;mso-pagination:widow-orphan;text-align:left;
        line-height:130%;"><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
        mso-bidi-font-family:'Times New Roman';line-height:130%;color:rgb(51,51,51);
        letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
        font-size:11.0000pt;mso-font-kerning:1.0000pt;">3. The winners of the Lucky Draw will be randomly selected from all participants who purchase Ulike products from 19 July 2023 (CEST) to 23 August 2023 (CEST).</span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
        mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:3.0000pt;margin-right:0.0000pt;margin-bottom:3.0000pt;
        margin-left:0.0000pt;mso-pagination:widow-orphan;text-align:left;
        line-height:130%;"><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
        mso-bidi-font-family:'Times New Roman';line-height:130%;color:rgb(51,51,51);
        letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
        font-size:11.0000pt;mso-font-kerning:1.0000pt;">4. All participants who purchase Ulike through the Ulike official website (ulike.com) can participate in the Lucky Draw.</span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
        mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:3.0000pt;margin-right:0.0000pt;margin-bottom:3.0000pt;
        margin-left:0.0000pt;mso-pagination:widow-orphan;text-align:left;
        line-height:130%;"><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
        mso-bidi-font-family:'Times New Roman';line-height:130%;color:rgb(51,51,51);
        letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
        font-size:11.0000pt;mso-font-kerning:1.0000pt;">5. The winners of the Lucky Draw will be announced daily on the campaign page.</span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
        mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:3.0000pt;margin-right:0.0000pt;margin-bottom:3.0000pt;
        margin-left:0.0000pt;mso-pagination:widow-orphan;text-align:left;
        line-height:130%;"><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
        mso-bidi-font-family:'Times New Roman';line-height:130%;color:rgb(51,51,51);
        letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
        font-size:11.0000pt;mso-font-kerning:1.0000pt;">6. The winners will be randomly selected from all valid Lucky Draw entries.</span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
        mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:3.0000pt;margin-right:0.0000pt;margin-bottom:3.0000pt;
        margin-left:0.0000pt;mso-pagination:widow-orphan;text-align:left;
        line-height:130%;"><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
        mso-bidi-font-family:'Times New Roman';line-height:130%;color:rgb(51,51,51);
        letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
        font-size:11.0000pt;mso-font-kerning:1.0000pt;">7. All winners will be notified via their registered email accounts. Participants must ensure that the details of their registrations are up-to-date, accurate, complete, and truthful in all respects.</span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
        mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:3.0000pt;margin-right:0.0000pt;margin-bottom:3.0000pt;
        margin-left:0.0000pt;mso-pagination:widow-orphan;text-align:left;
        line-height:130%;"><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
        mso-bidi-font-family:'Times New Roman';line-height:130%;color:rgb(51,51,51);
        letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
        font-size:11.0000pt;mso-font-kerning:1.0000pt;">8. All winners are welcome to share valuable feedback through posts, pictures, and comments about our products.</span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
        mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:3.0000pt;margin-right:0.0000pt;margin-bottom:3.0000pt;
        margin-left:0.0000pt;mso-pagination:widow-orphan;text-align:left;
        line-height:130%;"><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
        mso-bidi-font-family:'Times New Roman';line-height:130%;color:rgb(51,51,51);
        letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
        font-size:11.0000pt;mso-font-kerning:1.0000pt;">Prize</span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
        mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:3.0000pt;margin-right:0.0000pt;margin-bottom:3.0000pt;
        margin-left:0.0000pt;mso-pagination:widow-orphan;text-align:left;
        line-height:130%;"><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
        mso-bidi-font-family:'Times New Roman';line-height:130%;color:rgb(51,51,51);
        letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
        font-size:11.0000pt;mso-font-kerning:1.0000pt;">The details of the prizes are as follows:</span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
        mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:3.0000pt;margin-right:0.0000pt;margin-bottom:3.0000pt;
        margin-left:0.0000pt;mso-pagination:widow-orphan;text-align:left;
        line-height:130%;"><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
        mso-bidi-font-family:'Times New Roman';line-height:130%;color:rgb(51,51,51);
        letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
        font-size:11.0000pt;mso-font-kerning:1.0000pt;">1st prize: Ulike Disinfection Box × 1080 winners (30 winners daily)</span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
        mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:3.0000pt;margin-right:0.0000pt;margin-bottom:3.0000pt;
        margin-left:0.0000pt;mso-pagination:widow-orphan;text-align:left;
        line-height:130%;"><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
        mso-bidi-font-family:'Times New Roman';line-height:130%;color:rgb(51,51,51);
        letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
        font-size:11.0000pt;mso-font-kerning:1.0000pt;">9. </span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
        mso-bidi-font-family:'Times New Roman';line-height:130%;color:rgb(51,51,51);
        letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
        font-size:11.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,0);
        mso-shading:rgb(255,255,0);">The winners will be informed via email and text. The corresponding product will be sent out by Ulike as the said order is processed from July 25th. </span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
        mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:3.0000pt;margin-right:0.0000pt;margin-bottom:3.0000pt;
        margin-left:0.0000pt;mso-pagination:widow-orphan;text-align:left;
        line-height:130%;"><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
        mso-bidi-font-family:'Times New Roman';line-height:130%;color:rgb(51,51,51);
        letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
        font-size:11.0000pt;mso-font-kerning:1.0000pt;">10. Prizes are not transferable, or exchangeable for cash or any other item. In the event of a refund of the original order, the prize must be sent back together for the refund to be successfully processed.</span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
        mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:3.0000pt;margin-right:0.0000pt;margin-bottom:3.0000pt;
        margin-left:0.0000pt;mso-pagination:widow-orphan;text-align:left;
        line-height:130%;"><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
        mso-bidi-font-family:'Times New Roman';line-height:130%;color:rgb(51,51,51);
        letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
        font-size:11.0000pt;mso-font-kerning:1.0000pt;">11. In the event that any prizes are awarded to a participant who has provided false or incorrect personal information, Ulike reserves the right to revoke the Participant's eligibility for the said prizes.</span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
        mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:3.0000pt;margin-right:0.0000pt;margin-bottom:3.0000pt;
        margin-left:0.0000pt;mso-pagination:widow-orphan;text-align:left;
        line-height:130%;"><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
        mso-bidi-font-family:'Times New Roman';line-height:130%;color:rgb(51,51,51);
        letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
        font-size:11.0000pt;mso-font-kerning:1.0000pt;">12. The prize images presented in the campaign are solely for reference purposes, and the availability of the actual prizes may be subject to change. All prizes accompanying purchases during the campaign are non-refundable and non-exchangeable. In the event of a product return, the complimentary prize must be returned along with the purchased item. Failure to return the prize will result in a deduction of the corresponding gift value ($80) from the refund amount.</span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
        mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:3.0000pt;margin-right:0.0000pt;margin-bottom:3.0000pt;
        margin-left:0.0000pt;mso-pagination:widow-orphan;text-align:left;
        line-height:130%;"><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
        mso-bidi-font-family:'Times New Roman';line-height:130%;color:rgb(51,51,51);
        letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
        font-size:11.0000pt;mso-font-kerning:1.0000pt;">13. Participants in the campaign agree to be bound by the terms and conditions set forth herein and understand that Ulike's decisions are final and binding. No correspondence or appeals will be entertained. Ulike reserves the right to make the final and ultimate interpretation of this campaign.</span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
        mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:3.0000pt;margin-right:0.0000pt;margin-bottom:3.0000pt;
        margin-left:0.0000pt;mso-pagination:widow-orphan;text-align:left;
        line-height:130%;"><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
        mso-bidi-font-family:'Times New Roman';line-height:130%;color:rgb(51,51,51);
        letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
        font-size:11.0000pt;mso-font-kerning:1.0000pt;">14. Ulike will not assume responsibility for late entries which may occur for any reason, including but not limited to network transmission failure.</span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
        mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:3.0000pt;margin-right:0.0000pt;margin-bottom:3.0000pt;
        margin-left:0.0000pt;mso-pagination:widow-orphan;text-align:left;
        line-height:130%;"><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
        mso-bidi-font-family:'Times New Roman';line-height:130%;color:rgb(51,51,51);
        letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
        font-size:11.0000pt;mso-font-kerning:1.0000pt;">15. Ulike will not be responsible for any direct or indirect losses or damages incurred by any party, including the participants, in connection with, or arising from acts or omissions, or any way related to this campaign.</span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
        mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:3.0000pt;margin-right:0.0000pt;margin-bottom:3.0000pt;
        margin-left:0.0000pt;mso-pagination:widow-orphan;text-align:left;
        line-height:130%;"><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
        mso-bidi-font-family:'Times New Roman';line-height:130%;color:rgb(51,51,51);
        letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
        font-size:11.0000pt;mso-font-kerning:1.0000pt;">16. Participants further agree to release and discharge any third party related to or connected with this campaign from any liabilities and claims, including breach of contract, tort, negligence, or any other cause of action at law or equity, arising out of, or in any way connected to this campaign, or the participant's entry into the campaign.</span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
        mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:3.0000pt;margin-right:0.0000pt;margin-bottom:3.0000pt;
        margin-left:0.0000pt;mso-pagination:widow-orphan;text-align:left;
        line-height:130%;"><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
        mso-bidi-font-family:'Times New Roman';line-height:130%;color:rgb(51,51,51);
        letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
        font-size:11.0000pt;mso-font-kerning:1.0000pt;">17. If participants are found to be using or have used inappropriate means to participate in this campaign, Ulike reserves the right to disqualify the participant's eligibility, including, without hesitation, the commencement of legal proceedings to the full extent of the applicable laws.</span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
        mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:3.0000pt;margin-right:0.0000pt;margin-bottom:3.0000pt;
        margin-left:0.0000pt;mso-pagination:widow-orphan;text-align:left;
        line-height:130%;"><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
        mso-bidi-font-family:'Times New Roman';line-height:130%;color:rgb(51,51,51);
        letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
        font-size:11.0000pt;mso-font-kerning:1.0000pt;">18. Ulike reserves the right to modify and/or cancel the terms and conditions herein at any time at its sole discretion.</span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
        mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:3.0000pt;margin-right:0.0000pt;margin-bottom:3.0000pt;
        margin-left:0.0000pt;mso-pagination:widow-orphan;text-align:left;
        line-height:130%;"><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
        mso-bidi-font-family:'Times New Roman';line-height:130%;color:rgb(51,51,51);
        letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
        font-size:11.0000pt;mso-font-kerning:1.0000pt;">19. This Campaign and the terms and conditions herein shall be governed by the laws of the country.</span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
        mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal"><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
        mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p>&nbsp;</o:p></span></p>
         
        </div>
      </div>`;
      // 将视频源元素添加到视频元素中
      body.appendChild(w);
      clickCloseAll(".close-btn");
      clickCloseAll(".popu-mask");
      function clickCloseAll(className) {
        document
          .querySelector(className)
          .addEventListener("click", function (e) {
            document.body.style = "";
            if (isIE()) {
              document.getElementById("popu-cont").removeNode(!0);
            } else {
              document.getElementById("popu-cont").remove();
            }
          });
      }
      function isIE() {
        if (!!window.ActiveXobject || "ActiveXObject" in window) {
          return !0;
        } else {
          return !1;
        }
      }
    });
  }
}

textDialog(document.getElementsByClassName("slideshow__btn-link"));

targetElement(document.getElementsByClassName("ipl_to_link"));
popu(document.getElementsByClassName("popu-video"), "video");

// subscriptePopu(document.getElementsByClassName('popu_subscripte'));

//复制折扣码方法 start
function copyCode(code, codeTxt, bt) {
  navigator.clipboard.writeText(code);
  bt.innerHTML = "Copied";
  setTimeout(() => {
    bt.innerHTML = codeTxt;
  }, 7000);
}
//复制折扣码方法 start
function copyCodeFun(code,callBack) {
  navigator.clipboard.writeText(code);
  if(callBack) callBack()
}
class Countdown {
  constructor(endTime, elName, loop = null) {
    this.displayElement = document.querySelector(elName);
    this.timer = null;
    this.loop = loop;
    this.setEndTime(endTime);
    this.start();
    this.locaName = elName + "loopTime";
  }
  setEndTime(endTime) {
    if (endTime) {
      this.endTime = new Date(endTime).getTime();
    } else {
      if (this.loop) {
        let locTime = localStorage.getItem(this.locaName);
        if (locTime && locTime * 1 > new Date().getTime()) {
          this.endTime = locTime * 1;
        } else {
          this.endTime = new Date().getTime() + 2 * 24 * 60 * 60 * 1000;
          localStorage.setItem(this.locaName, this.endTime);
        }
      } else {
        this.endTime = new Date().getTime();
      }
    }
  }
  start() {
    this.timer = setInterval(() => this.update(), 1000);
  }

  update() {
    const now = new Date().getTime();
    const distance = this.endTime - now;
    let hours = 0;
    let minutes = 0;
    let seconds = 0;

    if (distance < 0) {
      if (this.loop) {
        this.endTime = new Date().getTime() + 2 * 24 * 60 * 60 * 1000;
        localStorage.setItem(this.locaName, this.endTime);
      } else {
        clearInterval(this.timer);
        hours = 0;
        minutes = 0;
        seconds = 0;
      }
    } else {
      hours = Math.floor(distance / (1000 * 60 * 60));
      minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      seconds = Math.floor((distance % (1000 * 60)) / 1000);
    }

    this.displayElement.querySelector(".h").innerHTML = this.formatTime(hours);
    this.displayElement.querySelector(".m").innerHTML =
      this.formatTime(minutes);
    this.displayElement.querySelector(".s").innerHTML =
      this.formatTime(seconds);
  }
  formatTime(time) {
    return time < 10 ? `0${time}` : time;
  }
}

// 按钮添加loading

function btnShowLoading($p, isShow = true) {
  if (isShow) {
    $p.addClass("loading-btn-cus");
    $p.append('<span class="loading-span"></span>');
  } else {
    $p.removeClass("loading-btn-cus");
    $p.find(".loading-span").remove();
  }
}
